import { Accordion, AccordionDetails, AccordionSummary, Divider } from "@mui/material";
import { styled } from "@mui/material/styles";
import BSInput from "../../../common/js/components/BSInput";

const StyledResizeComment = styled(BSInput)(() => ({
    "& textarea": {
        resize: "vertical",
    },
}));

const CompCommentBlock = (props) => {
    const { data, disableInputs, handleInputChange } = props;
    return (
        <Accordion defaultExpanded expanded>
            <AccordionSummary>Comp Comments</AccordionSummary>
            <Divider />
            <AccordionDetails>
                <StyledResizeComment
                    id="compNotes"
                    label="Public Comments"
                    placeholder="Comments entered here are PUBLIC and will be VISIBLE on reports and excel exports."
                    value={data.compNotes}
                    multiline
                    rows={5}
                    onChange={(e) => handleInputChange("compNotes", e.target.value)}
                    disabled={disableInputs}
                />
            </AccordionDetails>
        </Accordion>
    );
};

export default CompCommentBlock;
